import Query from '../utils/Query';

export default class LikeService {

	static toggle(activityId, positive = true) {
		return Query.post('/custom/like/toggle/' + activityId + '/' + (positive ? 1 : -1));
	}
}
